import {
    LIST_NOTIFICATION_TYPES,
    LIST_NOTIFICATION_TYPES_SUCCESS,
    LIST_NOTIFICATION_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    notificationTypes: null,
    error: null,
    loading: false
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_NOTIFICATION_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_NOTIFICATION_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_NOTIFICATION_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                notificationTypes: action.payload
            }
        default:
            return state;
    }
}